export const URL = "https://api-conveniencia.inceres.com.br/", CDN = "https://cdn.inceres.com.br/"
